import { render, staticRenderFns } from "./SliDocIcon.vue?vue&type=template&id=0c61fd5a"
import script from "./SliDocIcon.vue?vue&type=script&lang=js"
export * from "./SliDocIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports